module.exports = __webpack_public_path__ + "static/media/undraw_file_sync_ot38.cb8be863.svg";